import { DatePipe } from '@angular/common';
import { Component, inject, input, OnChanges, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { Router } from '@angular/router';
import { EnhancedLoadingService } from '../../../../shared/services/enhanced-loading.service';
import { SmartOrpcClientService } from '../../../../shared/services/smart-orpc-client.service';
import {
  ModalCancellationMonitoringComponent,
  ModalCancellationMonitoringReturnType,
} from './modal-cancellation-monitoring/modal-cancellation-monitoring.component';
import { contractOutput } from '#backend/contract';
import { SnackbarService } from '../../../../shared/services/snackbar.service';

type BatchMonitoringRequest = contractOutput['monitoring']['byId'];

@Component({
  selector: 'app-detail-status-monitoring',
  standalone: true,
  imports: [MatRadioModule, MatIconModule, MatButtonModule, DatePipe],
  templateUrl: './detail-status-monitoring.component.html',
  styleUrl: './detail-status-monitoring.component.scss',
})
export class DetailStatusMonitoringComponent implements OnChanges {
  private orpc = inject(SmartOrpcClientService);
  data = input<BatchMonitoringRequest | null>(null);
  canUpload = signal(false);
  private loadingService = inject(EnhancedLoadingService);
  private snackBar = inject(SnackbarService);

  numeroRelatorioSol = null;
  numeroTotalRelatorioSol = null;
  //

  constructor(
    private router: Router,
    private dialog: MatDialog,
  ) {}

  ngOnChanges(): void {
    this.canUpload.set(
      (this.isValidating &&
        this.data()?.fileValidations?.every((v) => {
          return (
            v.status.id == 'REJECTED_BY_AUTO_VALIDATION' ||
            v.status.id == 'REJECTED_BY_MANUAL_VALIDATION'
          );
        })) ??
        false,
    );
  }

  // Métodos para verificar o status
  get isValidating(): boolean {
    return this.data()?.status?.code === 'VALIDATING_INPUT';
  }

  get isCompleted(): boolean {
    return this.data()?.status?.code === 'COMPLETED';
  }

  get isCancelled(): boolean {
    return this.data()?.status?.code === 'FAILED';
  }

  get isAnalyzing(): boolean {
    return this.data()?.status?.code === 'ANALYZING';
  }

  modalCancelamento() {
    const dialogRef = this.dialog.open<
      ModalCancellationMonitoringComponent,
      undefined,
      ModalCancellationMonitoringReturnType
    >(ModalCancellationMonitoringComponent, {
      width: '100%',
      maxWidth: '1020px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        this.loadingService.show();

        const requestId = this.data()?.id;
        if (!requestId) {
          this.loadingService.hide();
          return;
        }

        // Implementa o cancelamento usando o endpoint monitoring close
        this.orpc.client.monitoring
          .close({
            id: requestId,
            reason: result,
          })
          .then(() => {
            this.snackBar.alert(
              `Solicitação ${requestId} cancelada com sucesso! Motivo: ${result}`,
              -1,
            );
          })
          .catch((error: any) => {
            console.error('Erro ao cancelar solicitação:', error);
          })
          .finally(() => {
            this.loadingService.hide();
            window.location.reload(); //recarregar pagina
          });
      }
    });
  }

  onUploadFile() {
    console.log('Upload file for monitoring-safras');
    // TODO: Navigate to upload page for monitoring-safras
    this.router.navigate([
      '/monitoring-safras/adm/detail/' + this.data()?.id + '/upload',
    ]);
  }
}
